import { render } from "./ChamadosAbertosFechados.vue?vue&type=template&id=ed5260fa"
import script from "./ChamadosAbertosFechados.vue?vue&type=script&lang=js"
export * from "./ChamadosAbertosFechados.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__